// Parameters : (store) => (next) => (action) =>
export const redirectToRootIf401 = () => (next) => (action) => {
  // if (action.error?.message === "Request failed with status code 401") {
  // window.location.href = "/";
  // }

  next(action);
};
